import React, { useEffect } from "react";

import { downloadDocument } from "../../../../../../utils/common";
import styles from "../../../../Job/JobSwms/JobShiftPreStart/JobShiftPreStartView.module.css";
import layoutStyles from "../../EmergencyProceduresLayout.module.css";

export default function EmergencyProcedureMediaPreviewModal({
  isOpen,
  onClose,
  attachments,
  currentIndex,
  onNextClick,
  onPrevClick
}) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const onKeyDownCapture = (event) => {
      if (event.key !== "Escape") {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
      onClose();
    };

    document.addEventListener("keydown", onKeyDownCapture, true);
    return () => {
      document.removeEventListener("keydown", onKeyDownCapture, true);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !attachments[currentIndex]) {
    return null;
  }

  const current = attachments[currentIndex];
  const hasMultiple = attachments.length > 1;

  return (
    <div className={styles.PreviewPhotoPreviewOverlay} onClick={onClose}>
      <div className={styles.PreviewPhotoPreviewBody} onClick={(event) => event.stopPropagation()}>
        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            downloadDocument(current.fileUrl, true, null);
          }}
          className={styles.PreviewPhotoDownloadIcon}
          title="Download"
        >
          <svg height="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
            <path fill="currentColor" d="M128 128C128 92.7 156.7 64 192 64L341.5 64C358.5 64 374.8 70.7 386.8 82.7L493.3 189.3C505.3 201.3 512 217.6 512 234.6L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128zM336 122.5L336 216C336 229.3 346.7 240 360 240L453.5 240L336 122.5zM303 505C312.4 514.4 327.6 514.4 336.9 505L400.9 441C410.3 431.6 410.3 416.4 400.9 407.1C391.5 397.8 376.3 397.7 367 407.1L344 430.1L344 344C344 330.7 333.3 320 320 320C306.7 320 296 330.7 296 344L296 430.1L273 407.1C263.6 397.7 248.4 397.7 239.1 407.1C229.8 416.5 229.7 431.7 239.1 441L303.1 505z" />
          </svg>
          <span>Download</span>
        </button>

        <button
          type="button"
          className={styles.PreviewPhotoCloseIcon}
          onClick={(event) => {
            event.stopPropagation();
            onClose();
          }}
          title="Close preview"
        >
          <svg height="17px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
            <path fill="currentColor" d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z" />
          </svg>
        </button>

        {hasMultiple ? (
          <>
            <button
              type="button"
              className={`${styles.PreviewPhotoNav} ${styles.PreviewPhotoPrev}`}
              onClick={(event) => {
                event.stopPropagation();
                onPrevClick();
              }}
              title="Previous attachment"
            >
              <svg height="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                <path fill="currentColor" d="M169.4 297.4C156.9 309.9 156.9 330.2 169.4 342.7L361.4 534.7C373.9 547.2 394.2 547.2 406.7 534.7C419.2 522.2 419.2 501.9 406.7 489.4L237.3 320L406.6 150.6C419.1 138.1 419.1 117.8 406.6 105.3C394.1 92.8 373.8 92.8 361.3 105.3L169.3 297.3z" />
              </svg>
            </button>
            <button
              type="button"
              className={`${styles.PreviewPhotoNav} ${styles.PreviewPhotoNext}`}
              onClick={(event) => {
                event.stopPropagation();
                onNextClick();
              }}
              title="Next attachment"
            >
              <svg height="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                <path fill="currentColor" d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z" />
              </svg>
            </button>
          </>
        ) : null}

        <div className={styles.PreviewPhotoAttachment}>
          <div className={styles.PreviewPhotoImageWrapper}>
            {current.isPdf ? (
              <object
                data={current.fileUrl}
                type="application/pdf"
                className={layoutStyles.MediaPreviewPdfFrame}
              >
                <embed
                  src={current.fileUrl}
                  type="application/pdf"
                  className={layoutStyles.MediaPreviewPdfFrame}
                />
              </object>
            ) : (
              <img
                src={current.fileUrl}
                alt={current.title || "Photo Preview"}
                className={layoutStyles.MediaPreviewImageFrame}
              />
            )}
          </div>
        </div>

        <div className={styles.PreviewPhotoPreviewCaption}>
          <div className={styles.PreviewPhotoPreviewCaptionBody}>
            <div className={styles.PreviewPhotoPreviewCaptionTitleRow}>
              <span>{current.title || "-"}</span>
            </div>
            <div className={styles.PreviewPhotoPreviewMeta}>
              <div className={styles.PreviewPhotoPreviewComment}>{current.description || ""}</div>
            </div>
          </div>
          <span className={styles.PreviewPhotoPreviewCaptionCount}>
            {currentIndex + 1} / {attachments.length}
          </span>
        </div>
      </div>
    </div>
  );
}
